var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 10 10",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.29697808 4.96397436 4.59358974-4.59358974c.08461539-.08461539.08461539-.22205129 0-.30692308-.08487179-.08461539-.22230769-.08461539-.30692307 0l-4.59358975 4.59358974-4.59358974-4.59358974c-.08461538-.08461539-.22205128-.08461539-.30692308 0-.08461538.08487179-.08461538.22230769 0 .30692308l4.59358975 4.59358974-4.59358975 4.59358974c-.08461538.08461539-.08461538.22205128 0 .30692308.04256411.04230769.09794872.06358974.15358975.06358974.05538461 0 .11102564-.02128205.15333333-.06358974l4.59358974-4.59358974 4.59358975 4.59358974c.04230769.04230769.09794872.06358974.15333333.06358974.05564103 0 .11128205-.02128205.15358974-.06358974.08461539-.0848718.08461539-.22230769 0-.30692308z",
    fill: "#f00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ae672d0b292ff08c96f0be2b5aa370b3.svg";
export { ForwardRef as ReactComponent };